// extracted by mini-css-extract-plugin
export default {"separator":"SocialLogin_separator__UbwNH","wrapper":"SocialLogin_wrapper__nqbx2","button":"SocialLogin_button__CSikQ","icon":"SocialLogin_icon__C-y-i"};